import { PropTypes } from 'prop-types';
import { useDatepicker } from '@datepicker-react/hooks';
import Month from '../Month';
import DatepickerContext from '../datepickerContext';

const Picker = ({ value, blockArrows, handleDateChange, startFrom, endFrom }) => {
  const onChange = v => {
    handleDateChange(v);
  };

  const {
    firstDayOfWeek,
    activeMonths,
    isDateSelected,
    isDateHovered,
    isFirstOrLastSelectedDate,
    isDateBlocked,
    isDateFocused,
    focusedDate,
    onDateHover,
    onDateSelect,
    onDateFocus,
    goToPreviousMonths,
    goToNextMonths
  } = useDatepicker({
    startDate: value.startDate,
    endDate: value.endDate,
    focusedInput: value.focusedInput,
    firstDayOfWeek: 0,
    onDatesChange: onChange,
    numberOfMonths: 1,
    minBookingDate: startFrom,
    maxBookingDate: endFrom
    // initialVisibleMonth
  });

  return (
    <DatepickerContext.Provider
      value={{
        focusedDate,
        isDateFocused,
        isDateSelected,
        isDateHovered,
        isDateBlocked,
        isFirstOrLastSelectedDate,
        onDateSelect,
        onDateFocus,
        onDateHover
      }}
    >
      <div className="datepicker-months">
        {activeMonths.map((month, idx) => (
          <Month
            range
            key={`${month.year}-${month.month}`}
            year={month.year}
            idx={idx}
            last={activeMonths.length - 1}
            month={month.month}
            firstDayOfWeek={firstDayOfWeek}
            goToPreviousMonths={goToPreviousMonths}
            goToNextMonths={goToNextMonths}
            blockArrows={blockArrows}
          />
        ))}
      </div>
    </DatepickerContext.Provider>
  );
};

Picker.propTypes = {
  value: PropTypes.shape({
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
    focusedInput: PropTypes.string
  }).isRequired,
  handleDateChange: PropTypes.func.isRequired,
  customRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  blockArrows: PropTypes.bool,
  startFrom: PropTypes.instanceOf(Date),
  endFrom: PropTypes.instanceOf(Date)
};

Picker.defaultProps = {
  customRef: null,
  blockArrows: false,
  startFrom: null,
  endFrom: null
};

export default Picker;
